import { useMutation } from "@tanstack/react-query";
import { addGoogleAdsAccounts } from "../../api/bGoogleAdsApi";

export const useAddGoogleAdsAccounts = () => {
  return useMutation({
    mutationKey: ["add-google-ads-accounts"],
    mutationFn: (data) => addGoogleAdsAccounts(data),
    onError: (error) => {
      console.error("Adding Google Ads account error:", error.response || error);
    },
  });
};
